import type { ReplayStatus, ReplaySummary } from '@/services/captureApi';

export type ReplayChipTone = 'building' | 'ready' | 'fix' | 'failed';

export const isReplayBuilding = (status: ReplayStatus | null) => status === 'queued' || status === 'building';

export const isReplayBuilt = (status: ReplayStatus | null) => status === 'ready' || status === 'needs_fix';

export const matchPercent = (match: number) => `${Math.round(match * 1000) / 10}%`;

export function replayChip(status: ReplayStatus, summary: ReplaySummary | null): { label: string; tone: ReplayChipTone } {
  if (status === 'ready') {
    return { label: summary?.median != null ? `Ready · ${matchPercent(summary.median)}` : 'Ready', tone: 'ready' };
  }
  if (status === 'needs_fix') return { label: 'Needs a fix', tone: 'fix' };
  if (status === 'failed') return { label: 'Build failed', tone: 'failed' };
  return { label: 'Building', tone: 'building' };
}
